import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Create, FormTab, TabbedForm } from 'react-admin';
import { FormSpy } from 'react-final-form';
import omit from 'lodash/omit';

import CreateToolbar from '../../core/components/CreateToolbar';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import FormTitleBar from '../../core/components/FormTitleBar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import PresetSummary from './PresetSummary';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const PresetTitle = ({ record }) => {
  return (
    <FormTitleBar
      type="Document Profile"
      name=""
      status=""
      creation={true}
      showAvatar={false}
      avatarContent={'DP'}
      recordLabel="Document Profile"
    />
  );
};

class PresetCreate extends React.Component {
  state = {
    whenBlockNavigation: false
  };

  handleFormIsDirty(dirty) {
    // Block bnavigation when the form is dirty
    this.setState({ whenBlockNavigation: dirty });
  }
  allowNavigationOnSave = () => {
    this.setState({ whenBlockNavigation: false });
  };

  render() {
    const { whenBlockNavigation } = this.state;
    const { classes } = this.props;

    return (
      <React.Fragment>
        <NavigationPrompt when={whenBlockNavigation} creation>
          {(isOpen, onConfirm, onCancel) => (
            <LeaveConfirm
              isOpen={isOpen}
              onConfirm={onConfirm}
              onClose={onCancel}
            />
          )}
        </NavigationPrompt>
        <Create
          {...omit(this.props, [
            'userProfile',
            'hasCreatePermission',
            'hasEditPermission',
            'hasDeletePermission'
          ])}
          title={<PresetTitle />}
          classes={{ noActions: classes.noActions }}
        >
          <TabbedForm
            toolbar={
              <CreateToolbar
                allowNavigationOnSave={this.allowNavigationOnSave}
              />
            }
            variant="standard"
            margin="normal"
          >
            <FormTab label="Document Profile Details">
              <PresetSummary creation={true} />
              <FormSpy
                subscription={{ dirty: true }}
                onChange={props => {
                  const self = this;
                  setTimeout(() => self.handleFormIsDirty(props.dirty), 1);
                }}
              />
            </FormTab>
          </TabbedForm>
        </Create>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(PresetCreate);
